import React, { useState } from 'react';
import { XIcon, MousePointerIcon, MousePointerClickIcon, PlayIcon, PauseIcon } from 'lucide-react';
interface HeatmapModalProps {
  onClose: () => void;
}
export const HeatmapModal: React.FC<HeatmapModalProps> = ({
  onClose
}) => {
  const [heatmapType, setHeatmapType] = useState<'click' | 'mouse'>('click');
  const [isPlaying, setIsPlaying] = useState(false);
  const [playbackSpeed, setPlaybackSpeed] = useState<1 | 2>(1);
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-145">
      <div className="bg-white rounded-lg w-full max-w-4xl max-h-[90vh] flex flex-col" data-id="element-146">
        <div className="flex items-center justify-between p-4 border-b border-gray-200" data-id="element-147">
          <h3 className="font-medium" data-id="element-148">Heatmap & Replay</h3>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700" data-id="element-149">
            <XIcon size={20} data-id="element-150" />
          </button>
        </div>
        <div className="p-4 flex items-center justify-between border-b border-gray-200" data-id="element-151">
          <div className="flex items-center gap-2" data-id="element-152">
            <div className="flex items-center border border-gray-300 rounded-md overflow-hidden" data-id="element-153">
              <button className={`px-3 py-1.5 text-sm flex items-center gap-1 ${heatmapType === 'click' ? 'bg-gray-100' : 'bg-white'}`} onClick={() => setHeatmapType('click')} data-id="element-154">
                <MousePointerClickIcon size={14} data-id="element-155" />
                <span data-id="element-156">Klik-heatmap</span>
              </button>
              <button className={`px-3 py-1.5 text-sm flex items-center gap-1 ${heatmapType === 'mouse' ? 'bg-gray-100' : 'bg-white'}`} onClick={() => setHeatmapType('mouse')} data-id="element-157">
                <MousePointerIcon size={14} data-id="element-158" />
                <span data-id="element-159">Mouse-tracking heatmap</span>
              </button>
            </div>
          </div>
          <div className="flex items-center gap-2" data-id="element-160">
            <button className="border border-gray-300 rounded-md w-8 h-8 flex items-center justify-center" onClick={() => setIsPlaying(!isPlaying)} data-id="element-161">
              {isPlaying ? <PauseIcon size={16} data-id="element-162" /> : <PlayIcon size={16} data-id="element-163" />}
            </button>
            <button className={`border border-gray-300 rounded-md px-2 py-1 text-xs ${playbackSpeed === 2 ? 'bg-gray-100' : 'bg-white'}`} onClick={() => setPlaybackSpeed(playbackSpeed === 1 ? 2 : 1)} data-id="element-164">
              {playbackSpeed}x
            </button>
          </div>
        </div>
        <div className="flex-1 overflow-auto p-4 relative" data-id="element-165">
          <div className="bg-gray-100 rounded-lg h-96 flex items-center justify-center relative" data-id="element-166">
            {/* Placeholder for heatmap visualization */}
            <div className="text-center" data-id="element-167">
              {heatmapType === 'click' ? <div className="relative w-full h-full" data-id="element-168">
                  <div className="absolute top-1/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-24 h-24 bg-gradient-to-r from-yellow-200 via-red-500 to-red-500 rounded-full opacity-50" data-id="element-169"></div>
                  <div className="absolute top-2/3 left-1/3 transform -translate-x-1/2 -translate-y-1/2 w-16 h-16 bg-gradient-to-r from-yellow-200 via-red-500 to-red-500 rounded-full opacity-30" data-id="element-170"></div>
                </div> : <div className="relative w-full h-full" data-id="element-171">
                  <div className="absolute top-0 left-0 right-0 bottom-0 bg-gradient-to-b from-transparent via-yellow-200 to-red-500 opacity-20 rounded-lg" data-id="element-172"></div>
                  <svg className="absolute inset-0 w-full h-full" viewBox="0 0 400 300" data-id="element-173">
                    <path d="M50,150 C100,100 150,200 200,150 S300,100 350,150" stroke="#ef4444" strokeWidth="5" fill="none" strokeOpacity="0.5" data-id="element-174" />
                  </svg>
                </div>}
              <span className="text-sm text-gray-500" data-id="element-175">
                {heatmapType === 'click' ? 'Klik-heatmap' : 'Mouse-tracking heatmap'}{' '}
                visualisering
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>;
};